// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"285":"app-messages-fr_CA","1539":"question-sets-metadata","3546":"app-messages-en_CA"}[chunkId] + "." + {"285":"a82029e9","1539":"291c54bf","3546":"709766c9"}[chunkId] + ".chunk.js";
};